<template>
  <div>
    <div class="input-label" v-html="label"></div>
    <div class="">
      <div class="add-files--photos">
        <div
          v-for="(f, key) in photo"
          v-if="photo.length"
          :key="key"
          class="add-files--photo"
        >
          <v-avatar class="add-files--image-wrap" size="72" tile>
            <img :src="getUrl(f)" alt="image" class="add-files--image" />
            <div
              class="add-files--magnifying-glass-wrapper"
              @click="openFullScreen(f.url || f.base64)"
            >
              <v-icon class="add-files--magnifying-glass-icon"
                >mdi-magnify</v-icon
              >
            </div>
          </v-avatar>
          <i
            v-if="!disabled"
            class="add-files--image-delete"
            @click="$emit('delete', key)"
          >
            <svg
              fill="none"
              height="26"
              viewBox="0 0 26 26"
              width="26"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M26 13C26 20.1797 20.1797 26 13 26C5.8203 26 0 20.1797 0 13C0 5.8203 5.8203 0 13 0C20.1797 0 26 5.8203 26 13Z"
                fill="#D60000"
              />
              <path
                d="M10.6818 12.966L7.47728 9.7797C6.84091 9.01124 6.84091 8.24286 7.47728 7.47456C8.25 6.84181 9.02272 6.84181 9.79544 7.47456L13 10.7288L16.2046 7.54225C16.9773 6.9095 17.75 6.9095 18.5227 7.54225C19.1591 8.31071 19.1591 9.07909 18.5227 9.84739L15.3182 12.966L18.5227 16.1525C19.1591 16.9209 19.1591 17.6893 18.5227 18.4576C17.75 19.0904 16.9773 19.0904 16.2046 18.4576L13 15.3389L9.79544 18.5254C9.02272 19.1582 8.25 19.1582 7.47728 18.5254C6.84091 17.7571 6.84091 16.9887 7.47728 16.2203L10.6818 12.966Z"
                fill="white"
              />
            </svg>
          </i>
        </div>
        <div v-if="photo.length < maxFiles" class="add-files--photo">
          <div class="auth-form--wrap add-photo">
            <v-file-input
              :accept="acceptedFiles"
              :disabled="disabled"
              :hide-input="true"
              :rules="[rules.maxFiles, rules.minFiles, rules.fileSize]"
              class="mt-0 pt-0"
              multiple
              prepend-icon="mdi-camera-plus-outline"
              required
              @change="TransformFile"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- Show photo -->
    <v-dialog v-if="currentPhoto" v-model="showPhoto" max-width="800">
      <v-card class="objects__photo-preview">
        <v-img
          :src="currentPhoto.url"
          aspect-ratio="1.33"
          class="white--text objects__photo-img"
          title="фото"
        >
          <v-container fill-height fluid pa-2>
            <v-layout fill-height>
              <v-flex align-end flexbox text-right xs12>
                <i class="add-files--image-delete mt-2" @click="ClosePhoto">
                  <svg
                    fill="none"
                    height="32"
                    viewBox="0 0 32 32"
                    width="32"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M26 13C26 20.1797 20.1797 26 13 26C5.8203 26 0 20.1797 0 13C0 5.8203 5.8203 0 13 0C20.1797 0 26 5.8203 26 13Z"
                      fill="#638995"
                    />
                    <path
                      d="M10.6818 12.966L7.47728 9.7797C6.84091 9.01124 6.84091 8.24286 7.47728 7.47456C8.25 6.84181 9.02272 6.84181 9.79544 7.47456L13 10.7288L16.2046 7.54225C16.9773 6.9095 17.75 6.9095 18.5227 7.54225C19.1591 8.31071 19.1591 9.07909 18.5227 9.84739L15.3182 12.966L18.5227 16.1525C19.1591 16.9209 19.1591 17.6893 18.5227 18.4576C17.75 19.0904 16.9773 19.0904 16.2046 18.4576L13 15.3389L9.79544 18.5254C9.02272 19.1582 8.25 19.1582 7.47728 18.5254C6.84091 17.7571 6.84091 16.9887 7.47728 16.2203L10.6818 12.966Z"
                      fill="white"
                    />
                  </svg>
                </i>
              </v-flex>
            </v-layout>
          </v-container>
        </v-img>
      </v-card>
    </v-dialog>
    <!-- /Show photo -->

    <v-dialog
      v-if="currentPdf"
      v-model="showPdf"
      max-width="800"
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar color="primary" dark>
          <v-spacer></v-spacer>
          <v-btn dark icon @click="ClosePdf">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <div v-html="currentPdf"></div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'Photo',
  props: {
    customAccept: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    photo: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
    maxFiles: {
      type: Number,
      default: 1,
    },
    minFiles: {
      type: Number,
      default: 0,
    },
    maxFileSize: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
  },
  computed: {
    // Возможные файлы для выбора
    acceptedFiles() {
      let acceptedFiles;
      if (this.customAccept.length) {
        acceptedFiles = this.customAccept;
      } else {
        acceptedFiles = this.defaultAccept;
      }
      return acceptedFiles.join(',');
    },
  },
  data() {
    return {
      showPdf: false,
      currentPdf: null,
      showPhoto: false,
      currentPhoto: null,
      defaultAccept: ['image/png', 'image/jpeg', 'image/bmp'],
      rules: {
        required: v => !!v || 'Поле должно быть заполнено',
        maxFiles: () => this.photo.length < this.maxFiles
          || `Количество файлов не более ${this.maxFiles}`,
        minFiles: () => this.photo.length >= this.minFiles
          || `Количество файлов не менее ${this.minFiles}`,
        fileSize: v => !v || !v.size || v.size < 5242880 || 'Максимальный размер файла 5мб',
      },
    };
  },
  methods: {
    // TODO вынести функционал по открытию pdf в окне в отдельный компонент
    ShowPdf(photo) {
      this.showPdf = true;
      this.currentPdf = `<iframe src="${photo.url}" style="width:100%; min-height:700px" frameborder="0"></iframe>`;
    },
    ClosePdf() {
      this.showPdf = false;
      this.currentPdf = null;
    },
    openFullScreen(imgSrc) {
      if (imgSrc.indexOf('pdf') !== -1) {
        this.ShowPdf({ url: imgSrc });
        return;
      }
      const overlay = document.createElement('div');
      overlay.id = this.overlayId;
      overlay.style.position = 'absolute';
      overlay.style.background = '#00000073';
      overlay.style.width = '100%';
      overlay.style.height = '100%';
      overlay.style.top = '0';
      overlay.style.left = '0';
      overlay.style.zIndex = '500';
      overlay.style.display = 'flex';
      overlay.style.justifyContent = 'center';
      overlay.style.alignItems = 'center';

      const imageContainer = document.createElement('div');
      imageContainer.style.position = 'absolute';
      imageContainer.style.backgroundSize = 'contain';
      imageContainer.style.backgroundPosition = 'center';
      imageContainer.style.opacity = '1';
      imageContainer.style.height = '80%';

      const image = document.createElement('img');
      image.style.height = '100%';
      image.style.width = '100%';
      image.style.objectFit = 'cover';
      image.src = imgSrc;

      imageContainer.appendChild(image);

      const closeButton = document.createElementNS(
        'http://www.w3.org/2000/svg',
        'svg',
      );
      closeButton.setAttribute('width', '26');
      closeButton.setAttribute('height', '26');
      closeButton.setAttribute('viewBox', '0 0 26 26');
      closeButton.setAttribute('fill', 'none');

      closeButton.style.position = 'absolute';
      closeButton.style.right = '-12px';
      closeButton.style.top = '-12px';
      closeButton.style.cursor = 'pointer';
      closeButton.addEventListener('click', () => {
        const foundOverlay = document.getElementById(this.overlayId);
        if (foundOverlay) {
          document.body.removeChild(foundOverlay);
        }
      });

      const path1 = document.createElementNS(
        'http://www.w3.org/2000/svg',
        'path',
      );
      path1.setAttributeNS(
        null,
        'd',
        'M26 13C26 20.1797 20.1797 26 13 26C5.8203 26 0 20.1797 0 13C0 5.8203 5.8203 0 13 0C20.1797 0 26 5.8203 26 13Z',
      );
      path1.setAttributeNS(null, 'fill', '#D60000');

      const path2 = document.createElementNS(
        'http://www.w3.org/2000/svg',
        'path',
      );
      path2.setAttributeNS(
        null,
        'd',
        'M10.6818 12.966L7.47728 9.7797C6.84091 9.01124 6.84091 8.24286 7.47728 7.47456C8.25 6.84181 9.02272 6.84181 9.79544 7.47456L13 10.7288L16.2046 7.54225C16.9773 6.9095 17.75 6.9095 18.5227 7.54225C19.1591 8.31071 19.1591 9.07909 18.5227 9.84739L15.3182 12.966L18.5227 16.1525C19.1591 16.9209 19.1591 17.6893 18.5227 18.4576C17.75 19.0904 16.9773 19.0904 16.2046 18.4576L13 15.3389L9.79544 18.5254C9.02272 19.1582 8.25 19.1582 7.47728 18.5254C6.84091 17.7571 6.84091 16.9887 7.47728 16.2203L10.6818 12.966Z',
      );
      path2.setAttributeNS(null, 'fill', 'white');

      closeButton.appendChild(path1);
      closeButton.appendChild(path2);

      imageContainer.appendChild(closeButton);

      overlay.appendChild(imageContainer);
      document.body.appendChild(overlay);
    },
    // Получить урлу для отображения фото
    getUrl(photo) {
      const extension = this.getExtension(photo);
      if (extension === 'pdf') {
        return '/static/pdf-icon.png';
      }
      return photo.url || photo.base64;
    },
    // Получить расширение фото
    getExtension(photo) {
      const index = photo.name.lastIndexOf('.');
      return photo.name.slice(index + 1, photo.name.length);
    },
    /** Методы для работы с документами */
    async TransformFile(files, idx) {
      const file = files[0];
      const document = { file: '', url: '', name: '' };
      if (!file || file.name.lastIndexOf('.') <= 0) {
        return document;
      }
      const fr = new FileReader();
      await fr.readAsDataURL(file);
      await fr.addEventListener('load', () => {
        document.name = file.name;
        document.file = null;
        document.base64 = fr.result;
        document.key = `${idx}_${Date.now()}`;
        this.$emit('add', document);
      });
      return document;
    },
  },
};
</script>

<style lang="scss">
.add-files {
  margin-bottom: 15px;

  &--button {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;

    &-text {
      font-size: 12px;
    }

    @media (max-width: 600px) {
      flex-direction: column-reverse;
      align-items: flex-start;
      &-text {
        padding-bottom: 15px;
        padding-left: 0;
      }
    }
  }

  &--list {
    display: flex;
    flex-wrap: wrap;
    padding: 0 15px;
    border: 2px dashed #e6e8f0;
    border-radius: 8px;

    .add-photo {
      margin: 15px 30px 15px 0;
    }
  }

  &--photos {
    display: flex;
    flex-wrap: wrap;
  }

  &--photo {
    position: relative;

    &:hover {
      .add-files--magnifying-glass-wrapper {
        transition: opacity 0.3s;
        opacity: 0.5;
        visibility: visible;
        cursor: pointer;
      }
    }
  }

  &--magnifying-glass-wrapper {
    position: absolute !important;
    height: 100%;
    width: 100%;
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.3s;
    background: black;
    border-radius: 8px;
  }

  &--image-wrap {
    margin: 15px 15px 15px 0;
  }

  &--image {
    border-radius: 8px !important;
  }

  &--image-delete {
    position: absolute;
    top: 2px;
    right: 2px;
  }

  &--image-delete:hover {
    cursor: pointer;
  }
}

.add-photo {
  position: relative;
  width: 72px;
  margin-bottom: 20px;

  .v-input__control {
    display: none;
  }

  .v-input__icon {
    width: auto;
    height: auto;
  }

  .v-input__prepend-outer {
    margin: 0;

    button {
      padding: 18px;
      border: 1px solid #6a6a6a;
      border-radius: 16px;
      font-size: 34px;
      opacity: 0.5;

      &:hover {
        opacity: 1;
      }

      &:after {
        border-radius: 16px;
        transform: scale(1);
      }
    }
  }

  .ico-delete {
    position: absolute;
    right: -5px;
    bottom: -5px;
    line-height: 0;
  }

  .ico-delete:hover {
    cursor: pointer;
  }
}

.add-files--magnifying-glass-icon {
  color: white !important;
}

@media (max-width: 600px) {
  .add-photo {
    width: 50px;
    height: 50px;
    margin: 10px 12px 10px 0;

    .v-input__prepend-outer button {
      padding: 7px;
    }

    .ico-delete {
      width: 20px;
      height: 20px;

      svg {
        width: 100%;
        height: auto;
      }
    }
  }
}
</style>
